import {useEffect, useRef} from 'react';
import {Href} from '@sail/ui';
import {
  useWidgetControls,
  useWidgetVisibility,
  useWidget,
} from '../Widget/useWidget';
import {StripeAssistantHeader} from './StripeAssistantHeader';

type Props = {
  supportCenterHref?: Href;
  entryPoint?: string;
};

export function StripeAssistantWidgetHeader({
  supportCenterHref,
  entryPoint,
}: Props) {
  const ref = useRef<HTMLDivElement | null>(null);
  const {close, open, minimize, setMinimizedHeight} = useWidgetControls();
  const {visibility} = useWidgetVisibility();
  const widget = useWidget();

  useEffect(() => {
    if (ref.current) {
      setMinimizedHeight(ref.current.offsetHeight);
    }
  }, [setMinimizedHeight]);

  return (
    <StripeAssistantHeader
      ref={ref}
      minimized={visibility === 'minimized'}
      entryPoint={entryPoint}
      supportCenterHref={supportCenterHref}
      onMinimize={minimize}
      onOpen={open}
      onClose={close}
      onRestart={() => widget.restart()}
    />
  );
}
